// Автогенерировано screener-proto (cargo test -p screener-proto). Не редактировать руками.
export const PROTOCOL_VERSION = 12;
export const CLOSE_SESSION_INVALID = 4401;
export const CLOSE_STREAM_TAKEN = 4409;
export const CLOSE_ACCESS_CHANGED = 4403;
